export const FIELD_STATUSES = ['default', 'danger'] as const;

export type FieldStatus = (typeof FIELD_STATUSES)[number];
export type FieldSize = 'small' | 'default';
